export var version = '3.5.8';
//# sourceMappingURL=version.js.map